<div class="editor-body">
    <div class="template-info-row">
        <mat-form-field appearance="fill" class="name-field">
            <mat-label>Template Name</mat-label>
            <input matInput [(ngModel)]="templateName" />
        </mat-form-field>
        <button mat-stroked-button [disabled]="!templateName.trim() || saving"
            (click)="saveName.emit(templateName.trim())">
            <mat-icon>save</mat-icon> Save Name
        </button>
        <span class="layout-badge">{{ template.layoutMode }}</span>
    </div>

    <mat-divider />

    <div class="editor-columns">
        <app-state-list [allStates]="allStates" [template]="template" [selectedState]="selectedState"
            (stateSelected)="stateSelected.emit($event)" (removeLayout)="removeLayout.emit($event)" />

        <div class="slot-column-wrapper">
            @if (selectedState) {
            <mat-button-toggle-group [value]="selectedStateLayoutStyle"
                (change)="setStateLayoutStyle(selectedState, $event.value)" class="layout-style-toggle">
                @for (style of allLayoutStyles; track style) {
                <mat-button-toggle [value]="style">{{ style }}</mat-button-toggle>
                }
            </mat-button-toggle-group>
            }

            @if (selectedState) {
            <div class="container-style-row">
                <span class="container-style-label">Container Style</span>
                <mat-form-field appearance="fill" class="container-style-field">
                    <mat-label>Background Color</mat-label>
                    <input matInput [ngModel]="selectedStateContainerStyle.backgroundColor"
                        (ngModelChange)="setStateContainerStyleField(selectedState, 'backgroundColor', $event)"
                        placeholder="#1F2937" />
                </mat-form-field>
                <mat-form-field appearance="fill" class="container-style-field">
                    <mat-label>Text Color</mat-label>
                    <input matInput [ngModel]="selectedStateContainerStyle.color"
                        (ngModelChange)="setStateContainerStyleField(selectedState, 'color', $event)"
                        placeholder="#FFFFFF" />
                </mat-form-field>
                <mat-form-field appearance="fill" class="container-style-field">
                    <mat-label>Font Family</mat-label>
                    <input matInput [ngModel]="selectedStateContainerStyle.fontFamily"
                        (ngModelChange)="setStateContainerStyleField(selectedState, 'fontFamily', $event)"
                        placeholder="Arial, sans-serif" />
                </mat-form-field>
                <mat-form-field appearance="fill" class="container-style-field">
                    <mat-label>Padding</mat-label>
                    <input matInput [ngModel]="selectedStateContainerStyle.padding"
                        (ngModelChange)="setStateContainerStyleField(selectedState, 'padding', $event)"
                        placeholder="0" />
                </mat-form-field>
            </div>
            }

            @if (selectedState && selectedStateHasContent) {
            <div class="clone-state-row">
                <span class="clone-state-label">
                    <mat-icon>content_copy</mat-icon> Copy "{{ selectedState }}" to
                </span>
                <mat-form-field appearance="fill" class="clone-state-field">
                    <mat-label>Target state</mat-label>
                    <mat-select [(ngModel)]="cloneTargetState">
                        @for (state of cloneTargetOptions; track state) {
                        <mat-option [value]="state">{{ state }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <button mat-stroked-button [disabled]="!cloneTargetState || saving" (click)="onCloneState()">
                    <mat-icon>content_copy</mat-icon> Copy state
                </button>
            </div>
            }

            @if (selectedState && !selectedStateSlots?.length && !selectedStateLayers?.length) {
            <mat-button-toggle-group [value]="selectedEditorMode" (change)="setStateMode(selectedState, $event.value)"
                class="mode-toggle">
                <mat-button-toggle value="slot"><mat-icon>view_stream</mat-icon> Slot-Based</mat-button-toggle>
                <mat-button-toggle value="layer"><mat-icon>layers</mat-icon> Layer-Based</mat-button-toggle>
            </mat-button-toggle-group>
            }

            @if (selectedEditorMode === 'slot') {
            <app-slot-list [savedSlots]="slotsForEditor" [selectedState]="selectedState" [saving]="saving"
                [selectedTransientDurationSeconds]="transientDurationSeconds" [layoutStyle]="selectedStateLayoutStyle"
                (saveLayout)="onSaveLayout($event)" [errorMessage]="errorMessage" />
            } @else {
            <app-layer-list [savedLayers]="selectedStateLayers" [selectedState]="selectedState" [saving]="saving"
                (saveLayout)="onSaveLayout($event)" [selectedTransientDurationSeconds]="transientDurationSeconds"
                [errorMessage]="errorMessage" />
            }

        </div>
    </div>
</div>